import React from "react";
import {
  Button,
  Typography,
} from "@mui/material";
import { useSessionProvider } from "../../provider/SessionProvider";
import commonStyles from "../../styles/modal.module.css";
import { useTranslation } from "react-i18next";

interface IProps {
  onClose: () => void;
}

const SessionWarningModal = ({ onClose }: IProps) => {
  const {t} = useTranslation()
  return (
    <div className={commonStyles.sessionModalContent}>
      <div onClick={onClose} title="Close">
        <img src="/assets/cross.png" className={commonStyles.crossWrap} />
      </div>
      <div className={commonStyles.sessionModalTitle}>
        {t('sessionwarningmodal.title')}
      </div>
      <div className={commonStyles.sessionModalBody}>
        <Typography
          variant="body1"
          sx={{
            fontSize: "14px",
            color: "#333",
          }}
        >
          {t('sessionwarningmodal.description1')} <strong>5 {t('sessionwarningmodal.minutes')}</strong> {t('sessionwarningmodal.description2')}
        </Typography>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: "#fff",
            color: "var(--color-primary)",
            borderRadius: "4px",
            padding: "10px 32px",
            fontSize: "14px",
            fontWeight: "normal",
            textTransform: "none",
            border: "1px solid var(--color-primary)",
            "&:hover": {
              backgroundColor: "var(--color-primary-wash)",
            },
          }}
        >
          {t('button.okay')}
        </Button>
      </div>
    </div>
  );
};

export default SessionWarningModal;
